;(function () {
	const header = () => {
		const header = document.querySelector('.shopify-section-header')
		if (!header) return

		const menu = document.querySelector('.list-menu--inline')
		const menuLinks = document.querySelectorAll('.list-menu-item')
		const search = document.querySelector('.header__search')

		let vh = window.innerHeight * 0.01
		document.documentElement.style.setProperty('--vh', `${vh}px`)

		const annBar = document.querySelector('.section-announcement')
		if (header._nodusAnnObs) {
			header._nodusAnnObs.disconnect()
			header._nodusAnnObs = null
		}
		header._nodusAnnObs = new IntersectionObserver((entries) => {
			const [entry] = entries

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					'--ann-height',
					`${entry.intersectionRect.height}px`,
				)
			} else {
				document.documentElement.style.setProperty('--ann-height', `0px`)
			}
		})
		if (annBar) header._nodusAnnObs.observe(annBar)

		if (!header.dataset.nodusHeaderCoreInit) {
			header.dataset.nodusHeaderCoreInit = '1'

			header.addEventListener('keydown', (e) => {
				if (e.code === 'Escape' && search?.isOpen) {
					search.close()
				}
			})

			menuLinks.forEach((link) => {
				link.addEventListener('mouseenter', () => {
					if (link.classList.contains('list-menu--megamenu')) {
						if (link.classList.contains('list-menu--tabs')) {
							const megaMenu = link.querySelector('.mega-menu')
							const headerMain = header.querySelector('.header')
							if (!megaMenu || !headerMain) return
							const linkPosition = link.getBoundingClientRect().x
							megaMenu.style.left = `${linkPosition}px`
						}
						link.classList.add('list-menu--megamenu-visible')
						if (
							header.classList.contains('color-background-3') &&
							!header.classList.contains('shopify-section-header-sticky')
						) {
							header.classList.remove('color-background-3')
						}

						menuLinks.forEach((el) => {
							if (el !== link) {
								el.classList.remove('list-menu--megamenu-visible')
							}
						})
					} else {
						menuLinks.forEach((el) => {
							el.classList.remove('list-menu--megamenu-visible')
						})
					}
				})
			})

			if (menu) {
				menu.addEventListener('mouseleave', () => {
					menuLinks.forEach((link) => {
						link.classList.remove('list-menu--megamenu-visible')
					})
				})
			}

			if (!document.documentElement.dataset.nodusMouseFocusInit) {
				document.documentElement.dataset.nodusMouseFocusInit = '1'
				document.body.addEventListener('mousedown', function () {
					document.body.classList.add('mouse-focus')
				})

				document.body.addEventListener('keydown', function (e) {
					if (e.key === 'Tab') {
						document.body.classList.remove('mouse-focus')
					}
				})
			}

			const addBackground = () => {
				if (header._nodusBgAddObs) {
					header._nodusBgAddObs.disconnect()
					header._nodusBgAddObs = null
				}
				header._nodusBgAddObs = new ResizeObserver((entries) => {
					const [entry] = entries
					if (entry.contentRect.width >= 1200) {
						if (
							header.classList.contains('color-background-3') &&
							!header.classList.contains('shopify-section-header-sticky')
						) {
							header.classList.remove('color-background-3')
						}
					}
				})

				header._nodusBgAddObs.observe(header)
			}

			const removeBackground = () => {
				if (header._nodusBgRemoveObs) {
					header._nodusBgRemoveObs.disconnect()
					header._nodusBgRemoveObs = null
				}
				header._nodusBgRemoveObs = new ResizeObserver((entries) => {
					const [entry] = entries
					if (entry.contentRect.width >= 1200) {
						if (
							header.classList.contains('color-background-1') &&
							!header.classList.contains('shopify-section-header-sticky')
						) {
							header.classList.add('color-background-3')
						}
					}
				})

				header._nodusBgRemoveObs.observe(header)
			}

			header.addEventListener('mouseenter', addBackground)

			header.addEventListener('focus', addBackground)

			header.addEventListener('focusin', addBackground)

			header.addEventListener('mouseleave', removeBackground)

			header.addEventListener('focusout', removeBackground)
		}

		const megaMenuListLinks = () => {
			const megaMenuLinkWithSubmenu = document.querySelector('.mega-menu__list-item--children')
			const megaMenuLinks = document.querySelectorAll('.mega-menu__list-item')
			if (megaMenuLinkWithSubmenu) {
				megaMenuLinks.forEach((link) => {
					link.classList.add('mega-menu__list-item--opacity')
				})
				megaMenuLinkWithSubmenu.classList.remove('mega-menu__list-item--opacity')
				megaMenuLinkWithSubmenu.classList.add('mega-menu__list-item--visible')
			}
			$('.mega-menu__list-item').off('mouseenter.nodusHeader').on('mouseenter.nodusHeader', function () {
				if (megaMenuLinkWithSubmenu) {
					megaMenuLinkWithSubmenu.classList.remove('mega-menu__list-item--visible')
				}
				$(this).removeClass('mega-menu__list-item--opacity')
				$(this).siblings().addClass('mega-menu__list-item--opacity')
				$(this).off('mouseleave.nodusHeader').on('mouseleave.nodusHeader', () => {
					$(this).siblings().removeClass('mega-menu__list-item--opacity')
				})
			})
			$('.mega-menu__list-item').off('focus.nodusHeader').on('focus.nodusHeader', function () {
				if (megaMenuLinkWithSubmenu) {
					megaMenuLinkWithSubmenu.classList.remove('mega-menu__list-item--visible')
				}
				$(this).removeClass('mega-menu__list-item--opacity')
				$(this).siblings().addClass('mega-menu__list-item--opacity')
				$(this).off('mouseleave.nodusHeaderFocus').on('mouseleave.nodusHeaderFocus', () => {
					$(this).siblings().removeClass('mega-menu__list-item--opacity')
				})
			})
		}

		const megaMenuSublinks = () => {
			$('.mega-menu--list .mega-menu__submenu-item')
				.off('mouseenter.nodusHeader')
				.on('mouseenter.nodusHeader', function () {
					$(this).removeClass('mega-menu__submenu-item--opacity')
					$(this)
						.parent()
						.siblings()
						.find('.mega-menu__submenu-item')
						.addClass('mega-menu__submenu-item--opacity')
					$(this).off('mouseleave.nodusHeaderSub').on('mouseleave.nodusHeaderSub', () => {
						$(this)
							.parent()
							.siblings()
							.find('.mega-menu__submenu-item')
							.removeClass('mega-menu__submenu-item--opacity')
					})
				})
			$('.mega-menu--list .mega-menu__submenu-item')
				.off('focusin.nodusHeader')
				.on('focusin.nodusHeader', function () {
					$(this).removeClass('mega-menu__submenu-item--opacity')
					$(this)
						.parent()
						.siblings()
						.find('.mega-menu__submenu-item')
						.addClass('mega-menu__submenu-item--opacity')
					$(this).off('focusout.nodusHeaderSub').on('focusout.nodusHeaderSub', () => {
						$(this)
							.parent()
							.siblings()
							.find('.mega-menu__submenu-item')
							.removeClass('mega-menu__submenu-item--opacity')
					})
				})
		}

		const megaMenuTabs = () => {
			$('.mega-menu__tab-wrapper')
				.children()
				.find('.mega-menu__tab-wrapper')
				.first()
				.addClass('mega-menu__tab-wrapper--active')
			$('.mega-menu__tab-wrapper')
				.off('mouseenter.nodusHeader')
				.on('mouseenter.nodusHeader', function () {
					$('.mega-menu__tab-wrapper').removeClass('mega-menu__tab-wrapper--active')
					$(this).addClass('mega-menu__tab-wrapper--active')
				})
			$('.mega-menu__tab-wrapper')
				.off('focus.nodusHeader')
				.on('focus.nodusHeader', function () {
					$('.mega-menu__tab-wrapper').removeClass('mega-menu__tab-wrapper--active')
					$(this).addClass('mega-menu__tab-wrapper--active')
				})
			$('.mega-menu__tab-wrapper')
				.off('focusin.nodusHeader')
				.on('focusin.nodusHeader', function () {
					$('.mega-menu__tab-wrapper').removeClass('mega-menu__tab-wrapper--active')
					$(this).addClass('mega-menu__tab-wrapper--active')
				})
		}

		megaMenuListLinks()
		megaMenuSublinks()
		megaMenuTabs()

		const main = document.querySelector('main')
		const firstSection = main?.querySelectorAll('.shopify-section')?.[0]
		const breadcrumbs = document.querySelector('.breadcrumbs-wrapper')
		if (
			firstSection?.classList.contains('section--has-overlay') &&
			!firstSection?.classList.contains('not-margin')
		) {
			header.classList.add('color-background-1', 'color-background-3')
			if (breadcrumbs) {
				breadcrumbs.classList.add('color-background-3')
			}
		}
	}

	header()

	document.addEventListener('shopify:section:load', header)
	document.addEventListener('shopify:section:unload', header)
	document.addEventListener('shopify:section:reorder', header)
})()
